import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";


// Async thunk to fetch member user data
export const fetchBLMUsersData = createAsyncThunk('Data/fetchBLMUsersData', async () => {

    const res = await HttpClient.requestData("both-users", "GET", {});
    return res.data;

});


// Offer slice
const BLMSlice = createSlice({
    name: "BLMData",
    initialState: {
        status: 'idle',
        error: '',
        blmUsersCount: {
            pending: 0,
            approved: 0,
            paid: 0,
            suspended: 0,
            basic: 0,
            silver: 0,
            gold: 0,
            silverRequest: 0,
            goldRequest: 0
          },
    },
    reducers: {
        // Add reducers here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBLMUsersData.pending, (state) => {
                state.status = 'loading';
                state.error = ''; // Reset error
            })
            .addCase(fetchBLMUsersData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // state.memberData = action.payload;
                state.blmUsersCount = {
                    ...state.blmUsersCount,
                    pending: action.payload?.filter((item) => item?.status === "Pending").length || 0,
                    approved: action.payload?.filter((item) => item?.businessStatus && item?.status === "Active").length || 0,
                    paid: action.payload?.filter((item) => item?.paymentStatus).length || 0,
                    suspended: action.payload?.filter((item) => item?.suspendStatus).length || 0,
                    basic: action.payload?.filter((item) => item?.subscriptionData?._id === "66d89409094058c609c71832").length || 0,
                    silver: action.payload?.filter((item) => item?.subscriptionData?._id === "66d897a2094058c609c71836").length || 0,
                    gold: action.payload?.filter((item) => item?.subscriptionData?._id === "66d897d8094058c609c7183c").length || 0,
                    silverRequest: action.payload?.filter((item) => item?.planUpgradeRequested && item.upgradedSubscriptionId === "66d897a2094058c609c71836").length || 0,
                    goldRequest: action.payload?.filter((item) => item?.planUpgradeRequested && item.upgradedSubscriptionId === "66d897d8094058c609c7183c").length || 0
                  }
            })
            .addCase(fetchBLMUsersData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    }
});

// export const { } = offerSlice.actions
export default BLMSlice.reducer;